import React from 'react'
import List from './List'

const Articles = () => ({
  index: true,
  path: '/articles',
  element: <List />,
})

export default Articles
